import { render, staticRenderFns } from "./educational-material.vue?vue&type=template&id=0176a627&"
import script from "./educational-material.vue?vue&type=script&lang=ts&"
export * from "./educational-material.vue?vue&type=script&lang=ts&"
import style0 from "./educational-material.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports